module.exports = __webpack_public_path__ + "img/medal1.bdae3bce.svg";